import AutoAwesomeIcon from '@mui/icons-material/AutoAwesome';
import FilterListIcon from '@mui/icons-material/FilterList';
import { Badge, Stack } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import BasicTitle from './BasicTitle.js';
import { usePatients } from '../../api/index.js';
import { useCheckPermissions } from '../../auth/index.js';
import { toggleActivityReviewDrawer, toggleFilterDrawer } from '../../redux/reducers/drawers.js';
import { getPendingActivityEvents } from '../../redux/selectors.js';
import { EditLayoutToggle, LayoutTemplatePicker } from '../Layout/index.js';

const STREAMS_LAYOUT_SCOPE = 'streams';

const StreamsBarContent = () => {
  const dispatch = useDispatch();
  const { canReadActivityEvent } = useCheckPermissions();
  const matchedPatients = usePatients({
    includeCameras: true,
    includeInactive: false,
    includeMatched: true,
  });
  const matchedPatientsAvailable = matchedPatients?.data && matchedPatients.data.length > 0;
  const pendingCount = useSelector(getPendingActivityEvents).length;
  const tileIds = useMemo(
    () => (matchedPatients.data ?? []).map((p) => p.id),
    [matchedPatients.data],
  );

  return (
    <>
      <BasicTitle text={'Streams'} />
      {matchedPatientsAvailable ? (
        <Stack direction="row" alignItems="center" spacing={0.5} sx={{ marginLeft: 'auto' }}>
          <LayoutTemplatePicker scope={STREAMS_LAYOUT_SCOPE} tileIds={tileIds} />
          <EditLayoutToggle scope={STREAMS_LAYOUT_SCOPE} />
          <IconButton
            color="inherit"
            aria-label="open filter drawer"
            onClick={() => dispatch(toggleFilterDrawer(true))}
          >
            <FilterListIcon />
          </IconButton>
          {canReadActivityEvent ? (
            <IconButton
              color="inherit"
              aria-label="open AI review drawer"
              onClick={() => dispatch(toggleActivityReviewDrawer(true))}
            >
              <Badge
                badgeContent={pendingCount}
                color="primary"
                overlap="circular"
                max={99}
                invisible={pendingCount === 0}
                sx={{
                  '& .MuiBadge-badge': {
                    minWidth: 16,
                    height: 16,
                    fontSize: 10,
                    fontWeight: 600,
                    boxShadow: '0 0 0 2px #fff',
                  },
                }}
              >
                <AutoAwesomeIcon />
              </Badge>
            </IconButton>
          ) : null}
        </Stack>
      ) : null}
    </>
  );
};

export default StreamsBarContent;
